













export default {
  name: 'Pagination',
  data() {
    return {
      pageValue: this.value,
    };
  },
  props: {
    value: Number,
    length: Number,
    totalVisible: Number,
  },
  watch: {
    pageValue: function (val) {
      this.$emit('input', val);
    },
    value: function (val) {
      this.pageValue = val;
    },
  },
};
